import React, { useEffect, useState } from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { useGetLookUpDropdownListQuery } from '../../../../../../../api';
import { useLanguage } from '../../../../../../../contexts/LanguageContext';

const TypeOfWorkDropdown = ({ value, onChange, className, disabled, warrType }) => {
    const { getCurrentLanguageId } = useLanguage();
    const [selectedId, setSelectedId] = useState(null);

    const { data: rawOptions = [], isLoading } = useGetLookUpDropdownListQuery({
        RowCount: 100,
        GroupCode: 'XXBOS_TYPE_OF_WORK',
        LanguageId: getCurrentLanguageId()
    });

    // warrType'a göre filtrelenmiş seçenekler
    const options = React.useMemo(() => {
        const allOptions = rawOptions.map((item) => ({
            id: Number(item.code),
            text: item.translatedText
        }));

        // Eğer warrType belirtilmişse, ona göre filtrele
        if (warrType) {
            return allOptions.filter(option => {
                const text = option.text.toLowerCase();
                
                // warrType: "SW" (Servis Garantili) ise → sadece "servis" içerenleri göster
                if (warrType === 'SW') {
                    return text.includes('servis') || text.includes('service') || text.includes('warranty');
                }
                
                // warrType: "MO" (Müşteri Öder) ise → sadece "müşteri" içerenleri göster
                if (warrType === 'MO') {
                    return text.includes('müşteri') || text.includes('customer') || text.includes('paid');
                }
                
                return true;
            });
        }

        return allOptions;
    }, [rawOptions, warrType]);

    useEffect(() => {
        if (value === undefined || value === null) {
            setSelectedId(null);
        } else {
            setSelectedId(Number(value));
        }
    }, [value]);

    const handleChange = (e) => {
        const selectedId = Number(e.value);
        setSelectedId(selectedId);
        onChange?.(selectedId);
    };

    if (isLoading) {
        return <div>Yükleniyor...</div>;
    }

    return (
        <div className={`p-d-flex ${className}`} style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            {options.map((option) => (
                <div key={option.id} className="p-field-radiobutton" style={{ display: 'flex', alignItems: 'center' }}>
                    <RadioButton inputId={`radio-${option.id}`} name="typeOfWork" value={option.id} onChange={handleChange} checked={selectedId === option.id} disabled={disabled} />
                    <label htmlFor={`radio-${option.id}`} style={{ marginLeft: '0.5rem' }}>
                        {option.text}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default TypeOfWorkDropdown;
